import React from 'react';
import { Heart, Shield, Users } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <div className="flex items-center space-x-2">
              <Heart className="h-12 w-12 text-primary" />
              <span className="text-3xl font-bold text-gray-900">MedCard Pro</span>
            </div>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Smart Emergency Health Identity
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Revolutionizing emergency medical care with QR-based health profiles and real-time consent management
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Heart className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Life-Saving</h3>
            <p className="text-gray-600">
              Critical medical information available instantly when seconds matter most
            </p>
          </div>

          <div className="text-center">
            <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Secure</h3>
            <p className="text-gray-600">
              Bank-level encryption and real-time consent management protect your data
            </p>
          </div>

          <div className="text-center">
            <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="h-8 w-8 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Connected</h3>
            <p className="text-gray-600">
              Automatically notify emergency contacts and locate nearby hospitals
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">For Users</h3>
              <ol className="space-y-2 text-gray-600">
                <li>1. Create your health profile with medical information</li>
                <li>2. Add emergency contacts and important medical details</li>
                <li>3. Download your unique QR code</li>
                <li>4. Save it as phone wallpaper or print it</li>
                <li>5. Receive instant notifications when accessed</li>
                <li>6. Control access with one-tap approval</li>
              </ol>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">For Emergency Services</h3>
              <ol className="space-y-2 text-gray-600">
                <li>1. Scan the patient's QR code</li>
                <li>2. Wait for consent (60s auto-approval)</li>
                <li>3. Access critical medical information</li>
                <li>4. View allergies, medications, blood type</li>
                <li>5. Contact emergency contacts instantly</li>
                <li>6. Find nearby hospitals with directions</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
